import React, { useMemo, useState, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { UserListProps } from "../../../models/user.model";
import { USER_CONSTANTS } from "../../../constants/userConstants";
import { CAlert, CButton } from "@coreui/react";
import { useNavigate } from "react-router-dom";
import { PaginationChangedEvent } from "ag-grid-community";

const UserList: React.FC<UserListProps> = ({
  rowData,
  columnDefs,
  itemCount,
  handlegetAdminUser,
  loading,
  title,
}) => {
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const [currentPage, setCurrentPage] = useState(1);
  const gridApiRef = useRef<any>(null);
  const defaultColDef = useMemo(() => {
    return {
      width: 170,
      sortable: true,
      flex: 1,
      minWidth: 150,
      filter: "agTextColumnFilter",
      unSortIcon: true,
    };
  }, []);

  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const pageCountOptions = USER_CONSTANTS.PAGE_COUNT_LIST;
  const [detailsFound, setDetailsFound] = useState(true);
  const [pageCount, setPageCount] = useState(10);
  const [quickFilterText, setQuickFilterText] = useState("");
  const [onlyProShow, setOnlyProShow] = useState(false);
  const [row, setRow] = useState<any>([]);

  useEffect(() => {
    setRow(rowData);
  }, [rowData]);

  const onGridReady = (params: any) => {
    gridApiRef.current = params.api;
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
      handlegetAdminUser(
        pageCount,
        currentPage - 1,
        quickFilterText,
        Number(onlyProShow)
      );
    }
  };

  const handleNext = () => {
    const totalPages = Math.ceil(itemCount / pageCount);
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
      handlegetAdminUser(
        pageCount,
        currentPage + 1,
        quickFilterText,
        Number(onlyProShow)
      );
    }
  };

  const gridOptions = {
    quickFilterText: "",
    enableFilter: false,
  };
  const showProUsers = () => {
    setOnlyProShow(!onlyProShow);
    setCurrentPage(1);
    handlegetAdminUser(pageCount, 1, quickFilterText, Number(!onlyProShow));
  };
  const handlePageCountChange = (event: any) => {
    const newPageCount = parseInt(event.target.value, 10);
    setPageCount(newPageCount);
    setCurrentPage(1);
    handlegetAdminUser(newPageCount, 1, quickFilterText, Number(onlyProShow));
  };
  const handleQuickFilterChange = (event: any) => {
    const newQuickFilterText = event.target.value;
    setQuickFilterText(newQuickFilterText);
    setCurrentPage(1);
    handlegetAdminUser(pageCount, 1, newQuickFilterText, Number(onlyProShow));
  };

  const navigate = useNavigate();
  return (
    <div style={containerStyle}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h3>{title}</h3>
        <div className=" ">
          <input
            type="text"
            placeholder="Search..."
            value={quickFilterText}
            onChange={handleQuickFilterChange}
          />
        </div>
      </div>
      {detailsFound ? (
        <div style={gridStyle} className="ag-theme-alpine">
          <AgGridReact
            rowData={row}
            columnDefs={columnDefs}
            domLayout="autoHeight"
            defaultColDef={defaultColDef}
            gridOptions={gridOptions}
            overlayNoRowsTemplate={"No Data Found"}
            scrollbarWidth={20}
            paginationPageSize={pageCount}
            quickFilterText={quickFilterText}
            onGridReady={onGridReady}
          />
          <div className="d-flex justify-content-between align-items-center mt-2">
            <div className="page-size d-flex align-items-center">
              <div className="me-1">Entries:</div>
              <select id="pageCount" onChange={handlePageCountChange}>
                {pageCountOptions.map(count => (
                  <option key={count} value={count}>
                    {count}
                  </option>
                ))}
              </select>
              <div className="ms-2 pagination-info">
                Showing {(currentPage - 1) * pageCount + 1} to{" "}
                {Math.min(currentPage * pageCount, itemCount)} of {itemCount}{" "}
                records
              </div>
            </div>

            <div className="pagination-controls">
              <button
                className="btn btn-outline-primary me-2 mp-pagination-button"
                onClick={handlePrevious}
                disabled={currentPage === 1}
              >
                {"<"}
              </button>
              <span className="mx-2">Page {currentPage}</span>
              <button
                className="btn btn-outline-primary ms-2 mp-pagination-button"
                onClick={handleNext}
                disabled={currentPage >= Math.ceil(itemCount / pageCount)}
              >
                {">"}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <CAlert color={"info"} className="no-details-found text-center">
          No details found.
        </CAlert>
      )}
    </div>
  );
};

export default UserList;
